import {WCBaseComponent} from './components/WCBaseComponent.js';

import {WCBox} from './components/WCBox.js';
customElements.define('wc-box', WCBox);

import {WCBoxList} from './components/WCBoxList.js';
customElements.define('wc-box-list', WCBoxList);

import {WCHeading} from './components/WCHeading.js';
customElements.define('wc-heading', WCHeading);

import {WCSpinner} from './components/WCSpinner.js';
customElements.define('wc-spinner', WCSpinner);

import {WCAvatar} from './components/WCAvatar.js';
customElements.define('wc-avatar', WCAvatar);

import {WCPresetButton} from './components/WCPresetButton.js';
customElements.define('wc-preset-button', WCPresetButton);

import {WCDropdown, WCDropdownButton, WCDropdownButtonIcon, WCDropdownMenu, WCDropdownMenuItem, WCDropdownMenuItemAnchor, WCDropdownMenuItemIcon, WCDropdownMenuItemCaption} from './components/WCDropdown.js';
customElements.define('wc-dropdown', WCDropdown);
customElements.define('wc-dropdown-button', WCDropdownButton);
customElements.define('wc-dropdown-button-icon', WCDropdownButtonIcon);
customElements.define('wc-dropdown-menu', WCDropdownMenu);
customElements.define('wc-dropdown-menu-item', WCDropdownMenuItem);
customElements.define('wc-dropdown-menu-item-anchor', WCDropdownMenuItemAnchor);
customElements.define('wc-dropdown-menu-item-icon', WCDropdownMenuItemIcon);
customElements.define('wc-dropdown-menu-item-caption', WCDropdownMenuItemCaption);

import {WCAnchorPayload} from './components/WCAnchorPayload.js';
customElements.define('wc-anchor-payload', WCAnchorPayload);

import {WCAnchorPayloadPill} from './components/WCAnchorPayloadPill.js';
customElements.define('wc-anchor-payload-pill', WCAnchorPayloadPill);

$(document).on('click', '.aPayload', function (e) {
  let payload = decodeURIComponent($(this).data('payload'));
  sessionStorage.setItem('payload', payload);
});

import {WCListText} from './components/WCListText.js';
customElements.define('wc-list-text', WCListText);

import {WCListInfo} from './components/WCListInfo.js';
customElements.define('wc-list-info', WCListInfo);

import {WCListPagination} from './components/WCListPagination.js';
customElements.define('wc-list-pagination', WCListPagination);

import {WCListSearchSummary} from './components/WCListSearchSummary.js';
customElements.define('wc-list-search-summary', WCListSearchSummary);

import {WCListDl, WCListDt, WCListDd} from './components/WCListDl.js';
customElements.define('wc-list-dl', WCListDl);
customElements.define('wc-list-dt', WCListDt);
customElements.define('wc-list-dd', WCListDd);

import {WCListTableContainer, WCListTable, WCListTableTh, WCListTableTd} from './components/WCListTable.js';
customElements.define('wc-list-table-container', WCListTableContainer);
customElements.define('wc-list-table', WCListTable);
customElements.define('wc-list-table-th', WCListTableTh);
customElements.define('wc-list-table-td', WCListTableTd);

import {WCListGridContainer, WCListGridRow, WCListGridCol, WCListGridCard, WCListGridCardHeader, WCListGridCardBody, WCListGridCardFooter, WCListGridCardTitle} from './components/WCListGrid.js';
customElements.define('wc-list-grid-container', WCListGridContainer);
customElements.define('wc-list-grid-row', WCListGridRow);
customElements.define('wc-list-grid-col', WCListGridCol);
customElements.define('wc-list-grid-card', WCListGridCard);
customElements.define('wc-list-grid-card-header', WCListGridCardHeader);
customElements.define('wc-list-grid-card-body', WCListGridCardBody);
customElements.define('wc-list-grid-card-footer', WCListGridCardFooter);
customElements.define('wc-list-grid-card-title', WCListGridCardTitle);

import {WCSublistCard, WCSublistCardHeader, WCSublistCardBody, WCSublistListGroup, WCSublistListGroupItem, WCSublistItemStart, WCSublistItemEnd, WCSublistDl, WCSublistDt, WCSublistDd} from './components/WCSubList.js';
customElements.define('wc-sublist-card', WCSublistCard);
customElements.define('wc-sublist-card-header', WCSublistCardHeader);
customElements.define('wc-sublist-card-body', WCSublistCardBody);
customElements.define('wc-sublist-list-group', WCSublistListGroup);
customElements.define('wc-sublist-list-group-item', WCSublistListGroupItem);
customElements.define('wc-sublist-item-start', WCSublistItemStart);
customElements.define('wc-sublist-item-end', WCSublistItemEnd);
customElements.define('wc-sublist-dl', WCSublistDl);
customElements.define('wc-sublist-dt', WCSublistDt);
customElements.define('wc-sublist-dd', WCSublistDd);